<template>
  <canvas ref="myChart" id="myChart" width="250px"></canvas>
</template>

<script>
import Chart from 'chart.js'
export default {
  props: {
    data: {
      type: Object,
      required: true,
    }
  },
  computed: {
    total: {
      get() {
        return this.$store.state.statistics.stat.data.total
      }
    },
    male: {
      get() {
        return this.data['Male']
      }
    },
    female: {
      get() {
        return this.data['Female']
      }
    },
    others: {
      get() {
        return this.data['Others']
      }
    },
    notSpecified: {
      get() {
        // This fixes the missing data from users who did not choose any of the options
        return this.data['Rather not Specify']
        return (this.total - this.male - this.female - this.others) + this.data['Rather not Specify']
      }
    }
  },
  watch: {
    data(n, o) {
      if (n) {
        this.updateData()
      }
    }
  },
  methods: {
    updateData() {
      this.$chrt.data.datasets.forEach((dataset) => {
        dataset.data = [
          this.getPercentage(this.male),
          this.getPercentage(this.female),
          this.getPercentage(this.others),
          this.getPercentage(this.notSpecified)
        ]
      });
      this.$chrt.update()
    },
    getPercentage(val) {
      return Math.ceil((val / this.total) * 100)
    },
  },
  mounted() {
    let ctx = this.$refs.myChart
    this.$chrt = new Chart(ctx, {
      type: 'pie',
      data: {
        labels: ["Male", "Female", "Others", "Rather not specify"],
        datasets: [{
          label: 'Gender',
          data: [],
          backgroundColor: [
              'rgba(255, 99, 132, 0.4)',
              'rgba(54, 162, 235, 0.4)',
              'rgba(255, 206, 86, 0.4)',
              'rgba(75, 192, 192, 0.4)',
          ],
          borderColor: [
              'rgba(255,99,132, 1)',
              'rgba(54, 162, 235, 1)',
              'rgba(255, 206, 86, 1)',
              'rgba(75, 192, 192, 1)',
          ],
          borderWidth: 1
        }]
      },
      options: {
        legend: {
          display: true,
          position: 'left',
          labels: {
            boxWidth: 12
          }
        },
        tooltips: {
            enabled: true,
            mode: 'single',
            callbacks: {
                label: function(tooltipItems, data) {
                  let label = data.labels[tooltipItems.index]
                  let value = data.datasets[tooltipItems.datasetIndex].data[tooltipItems.index]
                  return `${label}: ${value}%`;
                }
            }
        },
        scales: {
          xAxes: [{

            display:false,
            gridLines: {
                display:false,
                drawBorder: false,
            },
          }],
          yAxes: [{
            display:false,
            ticks: {
                beginAtZero:true
            },
            gridLines: {
                display:false,
                drawBorder: false
            }
          }]
        },
      }
    });

    if (this.data) {
      this.updateData()
    }
  }
}
</script>

<style>

</style>
